import React from 'react';
import { Paper, IconButton } from '@mui/material';
import { ZoomOut } from '@mui/icons-material';

function ZoomAction({
  zoom,
  setZoom,
}: {
  zoom: number;
  setZoom: React.Dispatch<React.SetStateAction<number>>;
}) {
  if (Math.floor(zoom * 100) === 100) {
    return null;
  }
  return (
    <Paper
      sx={{
        // bgcolor: 'background.paper',
        position: 'absolute',
        bottom: '8px',
        left: '8px',
        p: 0.5,
      }}
    >
      <IconButton
        aria-label="zoom out"
        onClick={() => {
          setZoom(1);
        }}
        size="small"
        color="primary"
        sx={{}}
      >
        <ZoomOut />
      </IconButton>
    </Paper>
  );
}

export default ZoomAction;
